/* eslint-disable react-hooks/exhaustive-deps */
import { EVENT } from "@/constants/event";
import useAppStore from "@/context/store";
import histotyDbService from "@/utils/historyDB";
import { useRouter } from "next/router";
import { useCallback, useMemo, useState } from "react";
import { Case, Switch } from "react-if";
import { getMe, getSignup, logout } from "../../services";
import loginTracker from "../../tracker/report/loginTracker";
import registTracker from "../../tracker/report/registTracker";
import HBIcon from "../HBIcon";
import HBModal from "../HBModal";
import ModalWrap, { destroyAll } from "../HBModal/ModalWrap";
import styles from "./index.module.less";
import Login from "./login";
import Register from "./register";
import ResetPwd from "./resetPwd";
import Tab from "./shared/tab";
import { ThirdLogin } from "./shared/third";
import UserAgreement from "./shared/userAgreement";
import { WxLogin } from "./shared/wxLogin";
// 判断用户是否保存了配置信息，如果有的话替换本地的配置信息
export const checkPageSetting = (user) => {
  if (user?.user_config?.configs) {
    const pageSettingStr = JSON.stringify(user.user_config.configs);
    if (pageSettingStr !== window.localStorage.getItem("huaban-page-setting")) {
      window.localStorage.setItem("huaban-page-setting", pageSettingStr);
      window.dispatchEvent(new Event(EVENT.PAGE_SETTING_CHANGE));
    }
  }
};

function LoginView({ initType, onOk, onCancel, initialTel = "", title }) {
  const [type, setType] = useState(initType);
  const [defaultTel, setDefaultTel] = useState(initialTel);
  const setUser = useAppStore((s) => s.setUser);

  const onSwitchLogin = useCallback((tel) => {
    setDefaultTel(typeof tel === "string" ? tel : "");
    setType("login");
  }, []);

  const onLogin = useCallback((data) => {
    loginTracker({
      userId: data.user_id,
      login_type: "mobile",
      is_cache_login: false,
    });
    setUser(data);
    onOk && onOk(data);
    histotyDbService.changeUser(data);
  }, []);

  const onRegister = useCallback((data, type) => {
    registTracker(type || "mobile", data.user_id);
    setUser(data);
    onOk && onOk(data);
  }, []);

  const onThirdLogin = useCallback((data) => {
    if (data.isRegister) {
      registTracker(data.loginType, data.user.user_id);
    } else {
      loginTracker({
        userId: data.user.user_id,
        login_type: data.loginType,
        is_cache_login: false,
      });
    }
    setUser(data.user);

    histotyDbService.changeUser(data.user);
    onOk && onOk(data.user);
  }, []);

  const onWxLogin = useCallback(async (res) => {
    if (res.user) {
      const data = {};
      data.loginType = "wechat";
      const user = await getMe();
      data.user = user;
      onThirdLogin(data);
    } else {
      // setType("wx_register");
      await getSignup();
      const user = await getMe();
      onThirdLogin({
        isRegister: true,
        loginType: "wechat",
        user,
      });
    }
  }, []);

  if (type === "wechat") {
    return (
      <div
        className={styles.wechatLogin}
        data-dialog-title="微信扫码弹窗"
        data-gd-expose="dialog_expose"
      >
        <div className={styles.title}>{title || "微信扫码登录"}</div>
        <div className={styles.sub}>未注册的微信号将自动创建花瓣账号</div>
        <div className={styles.wechatQrcodeWrap}>
          <WxLogin onLogin={onWxLogin} />
          <div>
            <HBIcon type="ic_wechat1" />
            微信扫码
          </div>
        </div>
        <div className={styles.otherLogin}>
          <div className={styles.phone} onClick={() => setType("login")}>
            <HBIcon type="icon" />
            账号登录注册
          </div>
          <ThirdLogin onOk={onThirdLogin} />
        </div>
        <UserAgreement className={styles.bottom} />
      </div>
    );
  }

  return (
    <>
      {type !== "reset" && (
        <Tab
          active={type}
          onChangeTab={(active) => {
            setType(active);
          }}
        />
      )}
      <Switch>
        <Case condition={type === "login"}>
          <Login
            setType={setType}
            initialTel={defaultTel}
            onOk={onLogin}
            onCancel={onCancel}
            onThirdLogin={onThirdLogin}
            data-dialog-title="登录弹窗"
            data-gd-expose="dialog_expose"
          />
        </Case>
        <Case condition={type === "register"}>
          <Register
            setType={setType}
            onSwitchLogin={onSwitchLogin}
            onOk={onRegister}
            onThirdLogin={onThirdLogin}
          />
        </Case>
        <Case condition={type === "reset"}>
          <ResetPwd onCancel={onSwitchLogin} onOk={onSwitchLogin} />
        </Case>
      </Switch>
    </>
  );
}

function LoginModal({ initType = "wechat", title, ...props }) {
  return (
    <HBModal
      className={styles.modal}
      width={480}
      footer={null}
      closable={true}
      closeIcon={<HBIcon type="ic_clear2" />}
      {...props}
    >
      <LoginView initType={initType} title={title} {...props} />
    </HBModal>
  );
}

const LoginDialog = ModalWrap(LoginModal);

export default LoginDialog;

export function useLogin() {
  const router = useRouter();
  const { setUser } = useAppStore(({ setUser }) => ({
    setUser,
  }));

  return useMemo(() => {
    return {
      async login(props = {}) {
        return new Promise((resolve) => {
          // 关闭其他弹框，避免同时出现多个弹框
          destroyAll();
          LoginDialog.open({
            ...props,
            async onOk(data) {
              resolve(data);
            },
            onCancel() {
              resolve(false);
            },
          });
        });
      },

      async logout(redirect, isBlank) {
        await logout();
        setUser(null);
        if (redirect) {
          isBlank
            ? (window.location.href = redirect)
            : router.push(redirect || "/");
        }
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export function LoginCard({ initType = "wechat", onOk, ...props } = {}) {
  return (
    <div className={styles.loginCard}>
      <LoginView initType={initType} onOk={onOk} {...props} />
    </div>
  );
}
